/**
 * Contact form - AJAX submission with multi-file dropzone and previews
 *
 * @package WL_Theme
 */
(function () {
    'use strict';

    var forms = document.querySelectorAll('[data-testid="contact-form"]');
    if (!forms.length) return;

    var config = window.wlContactForm || {};
    var maxFileSize = config.maxFileSize || 10 * 1024 * 1024;
    var maxFiles = 5;
    var allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];

    forms.forEach(initForm);

    function initForm(form) {
        var submitBtn = form.querySelector('[type="submit"], .form__submit');
        var dropzone = form.querySelector('.form__dropzone');
        var fileInput = form.querySelector('input[type="file"]');
        var statusEl = form.querySelector('.form__message') || createStatusEl(form);
        var selectedFiles = [];

        if (dropzone && !fileInput) {
            fileInput = document.createElement('input');
            fileInput.type = 'file';
            fileInput.multiple = true;
            fileInput.accept = '.jpg,.jpeg,.png,.pdf';
            fileInput.style.display = 'none';
            form.appendChild(fileInput);
        }

        if (fileInput) {
            fileInput.style.display = 'none';
        }

        var previewContainer = null;
        if (dropzone) {
            previewContainer = document.createElement('div');
            previewContainer.className = 'form__file-list';
            dropzone.parentNode.insertBefore(previewContainer, dropzone.nextSibling);
        }

        // Dropzone events
        if (dropzone && fileInput) {
            dropzone.addEventListener('click', function () {
                fileInput.click();
            });

            dropzone.addEventListener('dragover', function (e) {
                e.preventDefault();
                dropzone.classList.add('form__dropzone--dragover');
            });

            dropzone.addEventListener('dragleave', function () {
                dropzone.classList.remove('form__dropzone--dragover');
            });

            dropzone.addEventListener('drop', function (e) {
                e.preventDefault();
                dropzone.classList.remove('form__dropzone--dragover');
                addFiles(e.dataTransfer.files);
            });

            fileInput.addEventListener('change', function () {
                addFiles(fileInput.files);
                fileInput.value = '';
            });
        }

        function addFiles(fileList) {
            for (var i = 0; i < fileList.length; i++) {
                var file = fileList[i];

                if (selectedFiles.length >= maxFiles) {
                    showStatus(statusEl, 'Maksymalnie ' + maxFiles + ' plikow.', 'error');
                    break;
                }

                if (file.size > maxFileSize) {
                    showStatus(statusEl, 'Plik "' + file.name + '" jest za duzy. Max ' + Math.round(maxFileSize / 1024 / 1024) + ' MB.', 'error');
                    continue;
                }

                if (allowedTypes.indexOf(file.type) === -1) {
                    showStatus(statusEl, 'Plik "' + file.name + '" - niedozwolony format. Dozwolone: JPG, PNG, PDF.', 'error');
                    continue;
                }

                var isDuplicate = selectedFiles.some(function (f) {
                    return f.name === file.name && f.size === file.size;
                });
                if (isDuplicate) continue;

                selectedFiles.push(file);
            }
            renderPreviews();
        }

        function renderPreviews() {
            if (!previewContainer) return;
            previewContainer.innerHTML = '';
            if (selectedFiles.length === 0) return;

            selectedFiles.forEach(function (file, index) {
                var item = document.createElement('div');
                item.className = 'form__file-item';

                var thumbHtml;
                if (file.type.indexOf('image/') === 0) {
                    thumbHtml = '<img class="form__file-thumb" src="" alt="' + escHtml(file.name) + '">';
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        var img = item.querySelector('.form__file-thumb');
                        if (img) img.src = e.target.result;
                    };
                    reader.readAsDataURL(file);
                } else {
                    thumbHtml = '<div class="form__file-thumb form__file-thumb--pdf">PDF</div>';
                }

                item.innerHTML =
                    thumbHtml +
                    '<div class="form__file-info">' +
                        '<span class="form__file-name">' + escHtml(file.name) + '</span>' +
                        '<span class="form__file-size">' + formatSize(file.size) + '</span>' +
                    '</div>' +
                    '<button type="button" class="form__file-remove" data-index="' + index + '" aria-label="Usun plik">&times;</button>';

                previewContainer.appendChild(item);
            });

            previewContainer.querySelectorAll('.form__file-remove').forEach(function (btn) {
                btn.addEventListener('click', function () {
                    var idx = parseInt(btn.getAttribute('data-index'), 10);
                    selectedFiles.splice(idx, 1);
                    renderPreviews();
                });
            });
        }

        // Inline validation on blur
        form.querySelectorAll('.form__input, .form__textarea').forEach(function (field) {
            field.addEventListener('blur', function () {
                validateField(field);
            });
            field.addEventListener('input', function () {
                // Clear error on typing, re-validate if was invalid
                var group = field.closest('.form__group');
                if (group && group.classList.contains('form__group--error')) {
                    validateField(field);
                }
            });
        });

        // Form submit
        form.addEventListener('submit', function (e) {
            e.preventDefault();

            // Validate all fields with inline feedback
            var hasErrors = false;
            form.querySelectorAll('.form__input, .form__textarea').forEach(function (field) {
                if (!validateField(field)) hasErrors = true;
            });

            // Check consent
            var consent = form.querySelector('[name="consent"]');
            if (consent && !consent.checked) {
                hasErrors = true;
                showStatus(statusEl, 'Wymagana jest zgoda na przetwarzanie danych.', 'error');
            }

            if (hasErrors) return;

            var formData = new FormData(form);
            formData.append('action', 'wl_contact_submit');
            formData.append('nonce', config.nonce || '');

            // Remove native file input data - we manage files manually
            formData.delete('wl_files[]');

            selectedFiles.forEach(function (file) {
                formData.append('attachment[]', file);
            });

            setLoading(submitBtn, true);
            showStatus(statusEl, '', '');

            fetch(config.ajaxUrl || '/wp-admin/admin-ajax.php', {
                method: 'POST',
                body: formData,
            })
            .then(function (response) { return response.json(); })
            .then(function (data) {
                setLoading(submitBtn, false);
                if (data.success) {
                    showStatus(statusEl, data.data.message || config.successMsg, 'success');
                    form.reset();
                    selectedFiles = [];
                    renderPreviews();
                    clearFieldStates(form);
                } else {
                    showStatus(statusEl, data.data.message || config.errorMsg, 'error');
                }
            })
            .catch(function () {
                setLoading(submitBtn, false);
                showStatus(statusEl, config.errorMsg || 'Wystapil blad. Sprobuj ponownie.', 'error');
            });
        });
    }

    function validateField(field) {
        var group = field.closest('.form__group');
        if (!group) return true;

        var isRequired = field.hasAttribute('required');
        var value = field.value.trim();
        var error = '';

        // Empty required field
        if (isRequired && !value) {
            var label = field.closest('form').querySelector('label[for="' + field.id + '"]');
            var fieldName = label ? label.textContent.replace(/\s*\*\s*$/, '').trim() : field.name;
            error = 'Pole "' + fieldName + '" jest wymagane.';
        }
        // Email format
        else if (field.type === 'email' && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            error = 'Podaj prawidlowy adres email (np. jan@firma.pl).';
        }
        // Phone format
        else if (field.type === 'tel' && value && value.replace(/[\s\-\+\(\)]/g, '').length < 9) {
            error = 'Podaj prawidlowy numer telefonu.';
        }

        // Get or create feedback element
        var feedback = group.querySelector('.form__field-feedback');
        if (!feedback) {
            feedback = document.createElement('div');
            feedback.className = 'form__field-feedback';
            group.appendChild(feedback);
        }

        if (error) {
            group.classList.remove('form__group--valid');
            group.classList.add('form__group--error');
            feedback.textContent = error;
            feedback.className = 'form__field-feedback form__field-feedback--error';
            return false;
        } else if (value) {
            group.classList.remove('form__group--error');
            group.classList.add('form__group--valid');
            feedback.innerHTML = '&#10003; Poprawnie wypelnione';
            feedback.className = 'form__field-feedback form__field-feedback--valid';
            return true;
        } else {
            // Empty non-required - neutral
            group.classList.remove('form__group--error', 'form__group--valid');
            feedback.textContent = '';
            feedback.className = 'form__field-feedback';
            return true;
        }
    }

    function clearFieldStates(form) {
        form.querySelectorAll('.form__group--valid, .form__group--error').forEach(function (g) {
            g.classList.remove('form__group--valid', 'form__group--error');
        });
        form.querySelectorAll('.form__field-feedback').forEach(function (f) {
            f.textContent = '';
            f.className = 'form__field-feedback';
        });
    }

    function showStatus(el, msg, type) {
        if (!el) return;
        el.textContent = msg;
        el.className = 'form__message' + (type ? ' form__message--' + type : '');
        el.style.display = msg ? 'block' : 'none';
    }

    function setLoading(btn, loading) {
        if (!btn) return;
        btn.disabled = loading;
        btn.setAttribute('aria-busy', loading ? 'true' : 'false');
        btn.classList.toggle('form__submit--loading', loading);
    }

    function createStatusEl(form) {
        var el = document.createElement('div');
        el.className = 'form__message';
        el.style.display = 'none';
        el.setAttribute('role', 'alert');
        el.setAttribute('aria-live', 'polite');
        form.appendChild(el);
        return el;
    }

    function formatSize(bytes) {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + ' KB';
        return (bytes / 1024 / 1024).toFixed(1) + ' MB';
    }

    function escHtml(str) {
        var div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    }
})();
